import React, { useContext } from 'react'
import cn from 'classnames'
import { Link, useHistory, useLocation } from 'react-router-dom'
import LayeredToggle from './LayeredToggle'
import { ThemeContext } from '../../context/2025/ThemeContext'

export const MenuBar = ({ className = '' }) => {
  const { isDarkMode } = useContext(ThemeContext)
  const history = useHistory()
  const { pathname } = useLocation()

  const navigate = (url) => {
    if (pathname !== url && window.scrollTo) {
      window.scrollTo(0, 0)
    }
    history.push(url)
  }

  const isActive = (url) => {
    return pathname.includes(url)
  }

  const menuItemClass = (url) =>
    cn({
      // Base styles
      'h4-dsk transition-colors duration-300 wavy-underline-hover': true,

      // Non-active state styles based on theme
      'text-white hover:text-lime': isDarkMode && !isActive(url),
      'text-black hover:text-lavender': !isDarkMode && !isActive(url),

      // Active state - apply with higher specificity
      'text-lime wavy-underline wavy-border-lime': isDarkMode && isActive(url),
      'text-lavender wavy-underline wavy-border-lavender': !isDarkMode && isActive(url),
    })

  return (
    <div
      className={cn(
        `relative flex items-center justify-end gap-10 ${
          isDarkMode ? 'bg-black' : 'bg-white'
        }  transition-colors duration-300`,
        className,
      )}
    >
      <nav
        className={`flex items-center gap-10 w-full justify-center  ${
          isDarkMode ? 'bg-black' : 'bg-white'
        } transition-colors duration-300`}
      >
        <ul
          className={`flex items-center gap-24  ${
            isDarkMode ? 'bg-black' : 'bg-white'
          } transition-colors duration-300`}
        >
          <li>
            <button onClick={() => navigate('/work')} className='focus:outline-none'>
              {/* Force styles directly based on theme */}
              <span className={menuItemClass('/work')}>Work</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/grads')} className='focus:outline-none'>
              <span className={menuItemClass('/grads')}>Graduates</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/events')} className='focus:outline-none'>
              <span className={menuItemClass('/events')}>Events</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/about')} className='focus:outline-none'>
              <span className={menuItemClass('/about')}>About</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/awards')} className='focus:outline-none'>
              <span className={menuItemClass('/awards')}>Awards</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/letterbox')} className='focus:outline-none'>
              <span className={menuItemClass('/letterbox')}>Letterbox</span>
            </button>
          </li>
          <li>
            <button onClick={() => navigate('/committee')} className='focus:outline-none'>
              <span className={menuItemClass('/committee')}>Committee</span>
            </button>
          </li>
        </ul>
      </nav>

      <div className='flex items-center justify-center gap-10'>
        {/* <Link
          to='/search'
          className={cn('flex items-center transition-colors duration-300 mr-3 link ', {
            'text-white hover:text-lime': isDarkMode,
            'text-black hover:text-lavender': !isDarkMode,
          })}
        > */}

        <button
          onClick={() => navigate('/search')}
          className='flex items-center focus:outline-none'
        >
          {/* <span className={menuItemClass('/search')}>Search</span> */}
          <div className='w-[22px] h-[22px] ml-4'>
            {isDarkMode ? (
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='hover:scale-[1.04] transition-transform duration-300'
              >
                <g id='Frame 76'>
                  <path
                    id='Vector'
                    d='M0.93934 22.9393C0.353553 23.5251 0.353553 24.4749 0.93934 25.0607C1.52513 25.6464 2.47487 25.6464 3.06066 25.0607L0.93934 22.9393ZM22.5 9.7C22.5 13.1242 19.7242 15.9 16.3 15.9V18.9C21.381 18.9 25.5 14.781 25.5 9.7H22.5ZM16.3 15.9C12.8758 15.9 10.1 13.1242 10.1 9.7H7.1C7.1 14.781 11.219 18.9 16.3 18.9V15.9ZM10.1 9.7C10.1 6.27584 12.8758 3.5 16.3 3.5V0.5C11.219 0.5 7.1 4.61898 7.1 9.7H10.1ZM16.3 3.5C19.7242 3.5 22.5 6.27583 22.5 9.7H25.5C25.5 4.61898 21.381 0.5 16.3 0.5V3.5ZM3.06066 25.0607L7.56066 20.5607L5.43934 18.4393L0.93934 22.9393L3.06066 25.0607ZM7.56066 20.5607L12.0607 16.0607L9.93934 13.9393L5.43934 18.4393L7.56066 20.5607Z'
                    fill='#DAFF01'
                  />
                </g>
              </svg>
            ) : (
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='hover:scale-[1.04] transition-transform duration-300'
              >
                <g id='Frame 76'>
                  <path
                    id='Vector'
                    d='M0.93934 22.9393C0.353553 23.5251 0.353553 24.4749 0.93934 25.0607C1.52513 25.6464 2.47487 25.6464 3.06066 25.0607L0.93934 22.9393ZM22.5 9.7C22.5 13.1242 19.7242 15.9 16.3 15.9V18.9C21.381 18.9 25.5 14.781 25.5 9.7H22.5ZM16.3 15.9C12.8758 15.9 10.1 13.1242 10.1 9.7H7.1C7.1 14.781 11.219 18.9 16.3 18.9V15.9ZM10.1 9.7C10.1 6.27584 12.8758 3.5 16.3 3.5V0.5C11.219 0.5 7.1 4.61898 7.1 9.7H10.1ZM16.3 3.5C19.7242 3.5 22.5 6.27583 22.5 9.7H25.5C25.5 4.61898 21.381 0.5 16.3 0.5V3.5ZM3.06066 25.0607L7.56066 20.5607L5.43934 18.4393L0.93934 22.9393L3.06066 25.0607ZM7.56066 20.5607L12.0607 16.0607L9.93934 13.9393L5.43934 18.4393L7.56066 20.5607Z'
                    fill='#000000'
                  />
                </g>
              </svg>
            )}
          </div>
        </button>

        <LayeredToggle />

      </div>
    </div>
  )
}

export default MenuBar
